<template>
    <v-card flat tile height="100%" class="d-flex flex-column">
      <v-toolbar dense>
        <v-text-field
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          label="Search chats"
          single-line
          hide-details
          dense
          class="mr-4"
        ></v-text-field>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="() => {}">
              <v-list-item-title>New group</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => {}">
              <v-list-item-title>Archived</v-list-item-title>
            </v-list-item>
            <v-list-item @click="() => {}">
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-list class="flex-grow-1 overflow-y-auto">
        <v-list-item
          v-for="chat in filteredChats"
          :key="chat.id"
          @click="$emit('select-chat', chat.id)"
          :class="{ 'selected': $store.state.chat.currentChat === chat.id }"
        >
          <v-list-item-avatar>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ chat.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ chat.lastMessage }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-list-item-action-text>{{ chat.timestamp }}</v-list-item-action-text>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-btn
        fab
        dark
        color="primary"
        bottom
        right
        fixed
        @click="openNewChatDialog"
      >
        <v-icon>mdi-message-plus</v-icon>
      </v-btn>
      <v-dialog v-model="newChatDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">New Chat</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newChatName"
              label="Enter contact name"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="newChatDialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="createNewChat">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </template>
  
  <script>
  export default {
    name: 'ChatList',
    data() {
      return {
        searchQuery: '',
        newChatDialog: false,
        newChatName: '',
      }
    },
    computed: {
      filteredChats() {
        return this.$store.state.chat.chats.filter(chat =>
          chat.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      }
    },
    methods: {
      openNewChatDialog() {
        this.newChatDialog = true
      },
      createNewChat() {
        if (this.newChatName.trim()) {
          // Here you would typically dispatch an action to create a new chat
          // For now, let's just log it
          console.log('Creating new chat with:', this.newChatName)
          this.newChatDialog = false
          this.newChatName = ''
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .selected {
    background-color: #ebebeb;
  }
  </style>